import { createFileRoute, notFound } from "@tanstack/react-router";

import { getContent } from "@/lib/cms.functions";
import { alternateLinks, normalizeLocale } from "@/lib/i18n";
import { ArticleView } from "@/components/site/ContentViews";
import { ClosingCta } from "@/components/site/Cta";
import { NotFoundBlock } from "@/components/site/NotFoundBlock";

export const Route = createFileRoute("/{-$locale}/cases/$slug")({
  staticData: { sitemap: false },
  loader: async ({ params }) => {
    const locale = normalizeLocale((params as { locale?: string }).locale);
    const item = await getContent({ data: { kind: "case", slug: params.slug, locale } });
    if (!item) throw notFound();
    return { locale, item };
  },
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {
        meta: [
          { title: "Page unavailable | factory.online" },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    const { item } = loaderData;
    return {
      meta: [
        { title: `${item.seoTitle} | factory.online` },
        { name: "description", content: item.seoDescription },
        { property: "og:title", content: item.seoTitle },
        { property: "og:description", content: item.seoDescription },
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: alternateLinks(`/cases/${item.slug}`),
    };
  },
  notFoundComponent: CasesNotFound,
  component: CasesDetail,
});

function CasesNotFound() {
  return (
    <NotFoundBlock
      title="Case Studies entry not found"
      lead="This case study may have been moved or unpublished."
      backTo="/cases"
      backLabel="Back to Case Studies"
    />
  );
}

function CasesDetail() {
  const { item, locale } = Route.useLoaderData();
  return (
    <>
      <ArticleView item={item} backTo="/cases" backLabel="All cases" locale={locale} />
      <ClosingCta />
    </>
  );
}
